module.exports = __webpack_public_path__ + "img/hero.ffec4320.jpeg";